
import Vue from 'vue';
import Close16 from '@carbon/icons-vue/es/close/16';
import {
  CvGrid,
  CvRow,
  CvColumn,
  CvButton,
  CvButtonSet,
  CvCheckbox,
} from '@carbon/vue';

export default Vue.extend({
  name: 'SmallDetailsConfirmation',
  components: {
    CvGrid,
    CvRow,
    CvColumn,
    CvButton,
    CvButtonSet,
    CvCheckbox,
    Close16,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      isChecked: false,
    };
  },

  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.$modal.show('small-details-confirmation');
      } else {
        this.$modal.hide('small-details-confirmation');
      }
    },
  },

  mounted() {
    if (this.isOpen) {
      this.$modal.show('small-details-confirmation');
    }
  },
});
